import { memo } from 'react'

import * as Styled from './styled'
import { Icon } from 'common-components'
import { TScrollDirection } from '../utils'
import LeftArrow from 'assets/svgr-icons/ArrowLeft.svg'

interface IArrowScrollButtonProps {
  direction: TScrollDirection
  onClick: () => void
  isVisible: boolean
}

const ArrowScrollButton: React.FC<IArrowScrollButtonProps> = ({
  direction,
  onClick,
  isVisible
}) => {
  return (
    <Styled.ArrowScrollButtonWrapper
      onClick={onClick}
      $direction={direction}
      $isVisible={isVisible}
    >
      <Icon size="small" icon={<LeftArrow />} color="secondarySemiDark" />
    </Styled.ArrowScrollButtonWrapper>
  )
}

export default memo(ArrowScrollButton)
